import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-retorno-email',
    templateUrl: './retorno-email.component.html',
    styleUrls: ['./retorno-email.component.scss']
})

export class RetornoEmailComponent implements OnInit {
    data;
    imageLoad;

    constructor(
        private translate: TranslateService,
        private titleService: Title,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.carregarDados();
        });
    }

    ngOnInit() {
        this.carregarDados();

        this.activatedRoute.queryParams.subscribe(params => {
            const metodo = params.metodo;
            const tipo = params.type;
            const url = params.url;
            const name = params.name;

            if (metodo != null && tipo != null) {
                if (metodo === 'imagemAberta' || metodo === 'timestamp') {
                    this.imageLoad = environment.url + this.router.url;
                } else {
                    if (metodo === 'linkClicado' && url != null && name != null) {
                        window.location.href = environment.url + this.router.url;
                    } else if (metodo === 'unsubscribe' && url != null) {
                        window.location.href = environment.url + this.router.url;
                    }
                }
            }

        });
    }

    carregarDados() {
        this.translate.get('RETORNO_EMAIL').subscribe(res => {
            this.data = res;
            this.titleService.setTitle(this.data.HEADER_TITLE);
        });
    }

}
